import type { FeedItem } from '@/mocks/gossip';
import { catMeta } from '@/mocks/gossip';

interface Props {
  item: FeedItem | null;
  onClose: () => void;
}

export default function ArticleModal({ item, onClose }: Props) {
  if (!item) return null;

  return (
    <div
      className="fixed inset-0 z-[90] flex items-center justify-center p-3 md:p-6"
      role="dialog"
      aria-modal="true"
      aria-label={item.title}
    >
      <button
        type="button"
        aria-label="关闭文章"
        onClick={onClose}
        className="absolute inset-0 bg-foreground-950/60 backdrop-blur-sm"
      />
      <div className="relative z-10 flex max-h-[90vh] w-full max-w-2xl flex-col overflow-hidden rounded-xl bg-background-50">
        <div className="flex items-center justify-between border-b border-background-200 px-5 py-3">
          <span className="inline-flex items-center gap-2">
            <span className="h-2 w-2 rounded-full bg-primary-500" />
            <span className="text-xs font-medium tracking-wide text-foreground-600">图文阅读 · {catMeta[item.cat]}</span>
          </span>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-secondary-100 text-foreground-700 transition hover:bg-primary-100 hover:text-primary-700"
          >
            <i className="ri-close-line text-base" />
          </button>
        </div>
        <div className="overflow-y-auto px-5 py-5 md:px-7">
          <div className="mb-3 flex items-center gap-3 text-xs text-foreground-500">
            <span className="rounded-full bg-accent-100 px-3 py-1 font-medium text-accent-800">瓜田精选</span>
            <span>{item.time}</span>
            <span className="inline-flex items-center gap-1">
              <i className="ri-fire-line text-primary-500" />
              {item.heat} 热度
            </span>
          </div>
          <h3 className="font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
            {item.title}
          </h3>
          <div className="mt-5 space-y-3 md:space-y-4">
            {item.body.map((p, i) => (
              <p key={i} className="text-sm leading-7 text-foreground-800 md:text-[15px]">
                {p}
              </p>
            ))}
          </div>
          <div className="mt-6 rounded-lg bg-background-100 px-4 py-3 text-xs leading-6 text-foreground-600">
            本文为瓜田周刊编辑部基于公开素材整理汇编，仅作娱乐资讯分享。如涉及需更正或删除的内容，欢迎通过页尾投稿邮箱与我们联系。
          </div>
        </div>
      </div>
    </div>
  );
}